module.exports = __webpack_public_path__ + "static/img/gzh.36ab697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gzh.jpg
// module id = d5S/
// module chunks = 39